<div class="asposetools">
  <div class="content-container">
    <app-breadcrumbs [items]="breadcrumbs" />
    <h1>{{ "page.title" | translate }}</h1>
    <h2>{{ "page.subTitle" | translate }}</h2>
    <h3 [innerHTML]="'page.poweredby' | translate"></h3>
    @if (fileUrl) {
    <div class="preview">
      <div class="img-container">
        <img [src]="fileUrl" alt="image" />
      </div>
    </div>

    @if (showOptions) {
    <app-options (optionsChange)="setOptions($event)" />
    } @if (!downloadReady && !process) {
    <button class="button" (click)="detectObject()">
      {{ "page.start" | translate }}
    </button>
    } @if (downloadReady && !process) {
    <button class="button" (click)="download()">
      {{ "page.download" | translate }}
    </button>
    } @if (process) {
    <button class="button" disabled (click)="detectObject()">
      {{ "page.processing" | translate }} {{ progress }}%
    </button>
    } } @else {
    <app-file-uploader
      (fileUploaded)="handleUpload($event)"
    ></app-file-uploader>
    }
  </div>
</div>

<section class="content-container">
  <app-info [description]="howTo" />
</section>
